import { post } from './fetch';

export const login = (body) => post('user/login', body);
export const autologin = () => post('user/me');
export const logout = () => post('user/logout');
